import {Col, message, Row, Skeleton, Space} from "antd";
import GetUploadFile from "../uiUtils/GetUploadFile";
import React, {useContext} from "react";
import {delay} from "lodash";
import {AppController} from "../App";
import {Label} from "../uiUtils/Helpers";


export default function LogoManager({logo, setLogo, advertiser, children, ...props}) {

    const controller = useContext(AppController);
    const acceptedLogoTypes = "image/*,.pdf,.eps";  //todo check pdfs work

    async function onSelectFile(file){
        try {
            const managedFile = await controller.uploadAdvertiserFile(advertiser, file, {
                fileClass: 'INPUT',
                fileType: 'NAME_ARTWORK'
            });
            //todo until we can wait for asset thumbnail
            const delayTime = 1000 * (file.type.match(/^image/i) ? 1 : 3);
            delay(()=>setLogo({...managedFile, name:advertiser.name}), delayTime);
            message.success(file.name+' uploaded as new logo');
        } catch (e) {
            message.error(file.name+' failed to uploaded');
        }
    }

    return <Row>
        <Col span={12}>
            <Space direction={'vertical'}>
                <Label>Advertiser Logo</Label>
                (optional)
                <GetUploadFile onSelect={onSelectFile} accept={acceptedLogoTypes}
                               buttonText={'Upload graphic'} disabled={!advertiser}/>
                {children}
            </Space>
        </Col>
        <Col span={12}>
            {(logo && logo.thumbUrl)
                ?
                <img src={logo.thumbUrl} style={{maxWidth: 150, maxHeight: 150}} alt='logo'/>
                :
                <>
                    <Skeleton.Image style={{width: 150, height: 150}}/>
                    <div style={{fontSize:'smaller', color:'gray'}}>
                        For best results upload an EPS or PNG with a transparent background.
                    </div>
                </>
            }
        </Col>
    </Row>
}